import '@inovua/reactdatagrid-community/index.css';
import React from 'react';
// import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';

import { Table, Column, HeaderCell, Cell} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}

export const SubscriptionGrid = ({dataSource, onRowClick}) => {
    return (
      <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
        <Column width={200} fixed sortable resizable>
            <HeaderCell>Subscription ID</HeaderCell>
            <Cell>{rowData => rowData._id}</Cell>
        </Column>
        </Table>
    )
}